import logoGrey5 from '../../assets/images/logo-grey5.svg';
import logoGreyF8 from '../../assets/images/logo-greyf8.svg';
import logoGrey3 from '../../assets/images/logo-grey3.svg';

const images = {
  logoGrey5,
  logoGreyF8,
  logoGrey3
};

export default images;



// WEBPACK FOOTER //
// ./src/modules/misc/images.js